import React from "react";
import CssBaseline from "@material-ui/core/CssBaseline";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Chip from "@material-ui/core/Chip";

import Container from "@material-ui/core/Container";
import {
  useStylesCAB,
  useStylesContainers,
  useStylesHed,
  useStylesSetting,
} from "../../../St/comps/UseStyle";

import { Toaster } from "react-hot-toast";
import basicDataAPI from "../../../api/basicData";
import useFormDataCRUD from "../../../components/Hooks/useEDSCURD";

import Swipeable from "../../../Fronts/Main/Swipeable";
import { Button, CircularProgress } from "@material-ui/core";
import axios from "axios";
import { uri } from "../../../help/Api";
import ZatcaForm from "./zatca-form";
import { sto } from "../../../Context/InshData";

const URL = uri + "Zatca/GenerateCSRAndOnboardingCSID";

function GenerateCSRAndOnboardingCSID(data) {
  return axios.post(URL, data);
}


export default function ZatcaSettings(props) {
  const { data, fetchURL } = props;
  const classesStt = useStylesSetting();
  const clasCAB = useStylesCAB();
  const defaultValues = {
    ...data,
    IsProductionMode: false,
    IsProductionCsr: false
  };

  const { onChange, submit, update, object,submitting } = useFormDataCRUD(
    null,
    GenerateCSRAndOnboardingCSID,
    undefined,
    undefined,
    defaultValues,
    null,
    fetchURL
  );

  const clsConts = useStylesContainers();
  const clashd = useStylesHed();

  const styheader = {
    textAlign: "center",
    backgroundColor: "#fff",
    height: "100vh",
    direction: "rtl",
  };

  return (
    <React.Fragment>
      <CssBaseline />

      <Container maxWidth="sm">
        <Toaster />
        
        <Typography component="div" style={styheader}>
          <Grid item container>
            <Grid item xs={12}>
              <Chip
                size="small"
                className={clashd.ChipHdSale}
                label={"Ztca Settings of the second phase"}
                color="primary"
              />
            </Grid>
            <Grid container xs={12}>
              <Grid
                item
                container
                lg={12}
                md={12}
                sm={12}
                sx={12}
                className={[clsConts.rootup]}
              >
                <Grid
                  item
                  container
                  spacing={2}
                  xs={12}
                  className={[clsConts.subUp, clsConts.subUpC]}
                >
                  <ZatcaForm
                    {...{
                      data,
                      object,
                      updateItems: submit,
                      onChange,
                    }}
                  />
                  <Grid item container className={classesStt.rootSett}>
                  <Typography component="div">
          this settings for one Branch only {sto?.branchi}
        </Typography>
                    <Button
                      variant="contained"
                      className={classesStt.btn}
                      color="primary"
                      fontSize="large"
                      disabled={submitting}
                      onClick={() => {
                        update(object);
                      }}
                    >
                      {"Generate certificate "}
                    </Button>
                    {submitting && (
                      <CircularProgress
                        size={24}
                        className={clasCAB.buttonProgressCAB}
                      />
                    )}
                    <Swipeable />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Typography>
      </Container>
    </React.Fragment>
  );
}
